(function () {
  'use strict';

  var root = document.querySelector('[data-custom-chopstick-configurator-root]');
  if (
    !root ||
    !root.configuratorApp ||
    !root.configuratorArtwork ||
    !root.configuratorDesignDocuments ||
    !window.ErsProofSubmission ||
    root.getAttribute('data-configurator-order-flow-initialized') === 'true'
  ) return;

  var orderFlow = root.querySelector('[data-configurator-order-flow]');
  var productDataElement = orderFlow && orderFlow.querySelector('[data-order-product-data]');
  if (!orderFlow || !productDataElement) return;

  var productData;
  try {
    productData = JSON.parse(productDataElement.textContent);
  } catch (error) {
    return;
  }
  if (!productData.product || !Array.isArray(productData.variants) || productData.variants.length < 2 || !productData.rules) return;

  var app = root.configuratorApp;
  var artworkApi = root.configuratorArtwork;
  var designDocuments = root.configuratorDesignDocuments;
  var form = orderFlow.querySelector('.custom-chopstick-order-form');
  var submitButton = orderFlow.querySelector('[data-order-submit]');
  var errorElement = orderFlow.querySelector('[data-order-error]');
  var emailInput = orderFlow.querySelector('[data-order-email]');
  var proofStorageEndpoint = orderFlow.getAttribute('data-proof-storage-endpoint') || '';
  var pipeline = null;
  var confirmationStage = orderFlow.querySelector('[data-order-stage="confirmation"]');
  var confirmationDetailsToggle = orderFlow.querySelector('[data-order-confirmation-details-toggle]');
  var confirmationDetails = orderFlow.querySelector('[data-order-confirmation-details]');
  var submissionSucceeded = Boolean(orderFlow.querySelector('[data-order-submission-succeeded]'));
  var CELEBRATION_STORAGE_PREFIX = 'ers:custom-chopstick-sleeve:confirmation-celebrated:';
  var currentArtwork = null;
  var artworkDocument = null;
  var artworkStatus = null;
  var destroyed = false;
  var confirmationCelebrationTimer = null;
  var confirmationCelebrationReference = null;
  var renderedConfirmationReference = null;
  var unsubscribeApp = null;
  var unsubscribeArtwork = null;

  root.setAttribute('data-configurator-order-flow-initialized', 'true');

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function money(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(cents || 0) / 100);
  }

  function number(value) {
    return new Intl.NumberFormat('en-US').format(Number(value || 0));
  }

  function variantById(id) {
    return productData.variants.find(function (variant) {
      return String(variant.id) === String(id);
    }) || null;
  }

  function printColorCount(designDocument) {
    if (!designDocument) return 1;
    return Math.max(1, Math.min(2, designDocuments.getKnownPrintColors(designDocument).length));
  }

  function derivePricing(snapshot) {
    var order = snapshot.configuration.order;
    var variant = variantById(order.chopstickId) || productData.variants[0];
    var minimumCases = Number(productData.rules.minimumCases);
    var quantity = Math.max(minimumCases, Math.floor(Number(order.quantity) || minimumCases));
    var detectedColors = printColorCount(snapshot.configuration.design.document);
    var colors = order.printColors === 1 || order.printColors === 2 ? order.printColors : detectedColors;
    var merchandiseTotal = Number(variant.price) * quantity;
    var setupFee = colors <= 1
      ? Number(productData.rules.oneColorSetupFee)
      : Number(productData.rules.twoColorSetupFee);
    return {
      product: productData.product,
      variant: variant,
      quantity: quantity,
      unitsPerCase: Number(productData.rules.unitsPerCase),
      totalUnits: quantity * Number(productData.rules.unitsPerCase),
      printColors: colors,
      detectedPrintColors: detectedColors,
      merchandiseTotal: merchandiseTotal,
      setupFee: setupFee,
      estimatedTotal: merchandiseTotal + setupFee,
      setupProductId: productData.rules.setupProductId,
      setupVariantId: productData.rules.setupVariantId
    };
  }

  function ensureOrderDefaults(snapshot) {
    var pricing = derivePricing(snapshot);
    var order = snapshot.configuration.order;
    if (
      String(order.chopstickId || '') === String(pricing.variant.id) &&
      Number(order.quantity) === pricing.quantity &&
      Number(order.printColors) === pricing.printColors
    ) return false;
    app.updateConfiguration({
      order: {
        chopstickId: String(pricing.variant.id),
        quantity: pricing.quantity,
        printColors: pricing.printColors,
        contactEmail: order.contactEmail || ''
      }
    });
    return true;
  }

  function setText(selector, value) {
    Array.prototype.forEach.call(orderFlow.querySelectorAll(selector), function (element) {
      element.textContent = value;
    });
  }

  function drawPreview(target, source) {
    if (!target || !source) return;
    var context = target.getContext('2d');
    context.clearRect(0, 0, target.width, target.height);
    context.drawImage(source, 0, 0, source.width, source.height, 0, 0, target.width, target.height);
  }

  function renderPreviews() {
    if (!currentArtwork) return;
    ['front', 'back'].forEach(function (side) {
      Array.prototype.forEach.call(orderFlow.querySelectorAll('[data-order-preview="' + side + '"]'), function (canvas) {
        drawPreview(canvas, currentArtwork[side]);
      });
    });
  }

  function renderPricing(pricing) {
    setText('[data-order-summary-product]', pricing.variant.title);
    setText('[data-order-quantity]', String(pricing.quantity));
    setText('[data-order-case-count]', String(pricing.quantity));
    setText('[data-order-total-units]', number(pricing.totalUnits));
    setText('[data-order-units-per-case]', number(pricing.unitsPerCase) + ' pairs per case');
    setText('[data-order-summary-descriptor]', pricing.variant.descriptor);
    setText('[data-order-unit-breakdown]', number(pricing.unitsPerCase) + ' pairs per case × ' + pricing.quantity + ' cases');
    setText('[data-order-merchandise-line]', pricing.quantity + ' cases × ' + money(pricing.variant.price));
    setText('[data-order-merchandise-label]', pricing.variant.title + ' · ' + pricing.quantity + ' cases × ' + money(pricing.variant.price));
    setText('[data-order-merchandise-total]', money(pricing.merchandiseTotal));
    setText('[data-order-setup-label]', 'Setup fee (' + pricing.printColors + '-color)');
    setText('[data-order-setup-detail]', pricing.printColors + '-color');
    setText('[data-order-setup-fee]', money(pricing.setupFee));
    setText('[data-order-total]', money(pricing.estimatedTotal));

    Array.prototype.forEach.call(orderFlow.querySelectorAll('[data-order-product]'), function (input) {
      input.checked = String(input.value) === String(pricing.variant.id);
    });
    Array.prototype.forEach.call(orderFlow.querySelectorAll('[data-order-print-colors]'), function (input) {
      input.checked = Number(input.value) === pricing.printColors;
    });
    var decrease = orderFlow.querySelector('[data-order-quantity-step="-1"]');
    if (decrease) decrease.disabled = pricing.quantity <= Number(productData.rules.minimumCases);
    var reviewVisual = orderFlow.querySelector('[data-order-review-visual]');
    if (reviewVisual) {
      reviewVisual.classList.toggle('custom-chopstick-review-product__visual--twin', pricing.variant.visual === 'twin');
      reviewVisual.classList.toggle('custom-chopstick-review-product__visual--tenso', pricing.variant.visual === 'tenso');
    }
    var reviewImage = orderFlow.querySelector('[data-order-review-image]');
    if (reviewImage && pricing.variant.image) reviewImage.src = pricing.variant.image;
  }

  function setOrderPageScrolling(active) {
    document.documentElement.classList.toggle('configurator-order-page-scroll', active);
    document.body.classList.toggle('configurator-order-page-scroll', active);
  }

  function readSubmissionSnapshot() {
    return pipeline && pipeline.confirmation();
  }

  function confirmationProductLabel(submitted) {
    if (!submitted.productDescriptor) return submitted.productTitle;
    var shortDescriptor = submitted.productDescriptor.split('/')[0].trim();
    return submitted.productTitle + (shortDescriptor ? ' (' + shortDescriptor + ')' : '');
  }

  function celebrationWasPlayed(reference) {
    try {
      return window.sessionStorage.getItem(CELEBRATION_STORAGE_PREFIX + reference) === 'true';
    } catch (error) {
      return confirmationCelebrationReference === reference;
    }
  }

  function markCelebrationPlayed(reference) {
    try {
      window.sessionStorage.setItem(CELEBRATION_STORAGE_PREFIX + reference, 'true');
    } catch (error) {
      /* The verified submission snapshot already requires session storage. */
    }
  }

  function settleConfirmationCelebration() {
    confirmationCelebrationTimer = null;
    if (confirmationStage) confirmationStage.setAttribute('data-confirmation-celebration', 'settled');
  }

  function renderConfirmationCelebration(reference) {
    if (!confirmationStage || !reference) return;
    if (
      confirmationCelebrationReference === reference &&
      confirmationStage.getAttribute('data-confirmation-celebration') === 'playing'
    ) return;
    confirmationCelebrationReference = reference;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || celebrationWasPlayed(reference)) {
      markCelebrationPlayed(reference);
      settleConfirmationCelebration();
      return;
    }
    markCelebrationPlayed(reference);
    confirmationStage.setAttribute('data-confirmation-celebration', 'playing');
    if (confirmationCelebrationTimer) window.clearTimeout(confirmationCelebrationTimer);
    confirmationCelebrationTimer = window.setTimeout(settleConfirmationCelebration, 1850);
  }

  function renderConfirmation(submitted) {
    if (!submitted || !submitted.verified) return false;
    if (renderedConfirmationReference !== submitted.reference) {
      renderedConfirmationReference = submitted.reference;
      if (confirmationDetailsToggle) {
        confirmationDetailsToggle.setAttribute('aria-expanded', 'false');
        confirmationDetailsToggle.textContent = 'View details';
      }
      if (confirmationDetails) confirmationDetails.hidden = true;
    }
    setText('[data-order-confirmation-reference]', submitted.reference);
    setText('[data-order-confirmation-product]', confirmationProductLabel(submitted));
    setText('[data-order-confirmation-quantity]', submitted.quantity + ' cases (' + number(submitted.totalUnits) + ' pairs)');
    setText('[data-order-confirmation-setup]', submitted.printColors + '-color · ' + money(submitted.setupFee));
    setText('[data-order-confirmation-total]', money(submitted.estimatedTotal));
    renderConfirmationCelebration(submitted.reference);
    return true;
  }

  function render(snapshot) {
    if (destroyed) return;
    if (pipeline) pipeline.edited();
    var stage = snapshot.workflow.currentStage;
    var orderActive = ['chopsticks', 'review', 'confirmation'].indexOf(stage) !== -1;
    if (orderActive && stage !== 'confirmation' && ensureOrderDefaults(snapshot)) return;

    if (stage === 'confirmation' && !renderConfirmation(readSubmissionSnapshot())) {
      app.goTo('review', { focus: false });
      return;
    }

    Array.prototype.forEach.call(orderFlow.querySelectorAll('[data-order-stage]'), function (section) {
      section.hidden = section.getAttribute('data-order-stage') !== stage;
    });
    setOrderPageScrolling(orderActive);

    if (!orderActive || stage === 'confirmation') return;
    var pricing = derivePricing(snapshot);
    renderPricing(pricing);
    if (emailInput && document.activeElement !== emailInput) emailInput.value = snapshot.configuration.order.contactEmail || '';
    renderPreviews();
  }

  function handleArtwork(payload) {
    currentArtwork = payload && payload.front && payload.back ? { front: payload.front, back: payload.back } : null;
    artworkDocument = payload && payload.document;
    artworkStatus = payload && payload.status;
    renderPreviews();
  }

  function updateOrder(patch) {
    var snapshot = app.getState();
    app.updateConfiguration({
      order: Object.assign({}, snapshot.configuration.order, patch)
    });
  }

  // Keep Guided pricing, document resolution, and canvas rendering in the UI.
  // Once these inputs are resolved, the shared pipeline owns every submission step.
  async function submissionContext() {
    var email = emailInput.value.trim().toLowerCase();
    updateOrder({ contactEmail: email });
    var snapshot = app.getState(), configuration = snapshot.configuration;
    var document = configuration.design.document;
    var pricing = derivePricing(snapshot);
    var assets = {}, images = {}, logo = null;
    if (!document) throw new Error('Your design is still preparing. Please wait and retry.');
    var active = configuration.content.enabledTypes;
    for (var side of ['front', 'back']) {
      for (var object of document.sides[side].objects) {
        if (object.type !== 'image') continue;
        var module = designDocuments.getModuleForObject(object);
        if (module && active.indexOf(module) === -1) continue;
        var ref = object.assetRef;
        if (ref.kind === 'template') continue;
        var id = ref.kind === 'semantic' ? configuration.logo && configuration.logo.assetId : ref.assetId;
        var record = id && await root.logoAssets.get(id);
        if (!record || !record.blob) throw new Error('A required artwork source is missing. Please upload it again.');
        assets[id] = { blob: record.blob, name: record.name };
        if (ref.kind === 'semantic') logo = record; else images[id] = record;
      }
    }
    var templates = await root.configuratorProfessionalTemplates.loadForDocument(document);
    var resolved = designDocuments.resolveDocument(document, configuration, { logo: logo, images: images, templates: templates });
    ['front', 'back'].forEach(function (side) {
      resolved.sides[side].objects = resolved.sides[side].objects.map(function (item) {
        var object = { id: item.id, type: item.type, role: item.role, frame: clone(item.frame), rotation: item.rotation || 0, style: clone(item.style) };
        if (item.type === 'text') object.content = { kind: 'literal', value: item.text };
        else if (item.assetRef && item.assetRef.kind === 'template') {
          object.assetRef = clone(item.assetRef);
          var source = root.querySelector('[data-configurator-sample-source="' + item.assetRef.sourceId + '"]');
          object.assetRef.url = source && source.getAttribute('data-configurator-sample-source-url');
        } else object.assetRef = { kind: 'design', assetId: item.asset.id };
        return object;
      });
    });
    var started = Date.now();
    while (!currentArtwork || artworkStatus === 'missing' || JSON.stringify(artworkDocument) !== JSON.stringify(document) || root.getAttribute('data-configurator-artwork-preview') === 'loading') {
      if (Date.now() - started > 15000) throw new Error('Your latest artwork is still preparing. Your design is preserved; please retry.');
      await new Promise(function (resolve) { setTimeout(resolve, 50); });
    }
    await window.document.fonts.ready;
    return { designDocument: resolved, assets: assets, artwork: currentArtwork,
      order: { productId: pricing.product.id, productTitle: pricing.product.title, productUrl: pricing.product.url,
        variantId: pricing.variant.id, variantTitle: pricing.variant.title, variantDescriptor: pricing.variant.descriptor,
        sku: pricing.variant.sku || 'Not assigned', quantity: pricing.quantity, unitsPerCase: pricing.unitsPerCase,
        totalUnits: pricing.totalUnits, printColors: pricing.printColors, detectedPrintColors: pricing.detectedPrintColors,
        merchandiseTotal: pricing.merchandiseTotal, setupFee: pricing.setupFee, estimatedTotal: pricing.estimatedTotal },
      contact: { email: email, country: root.getAttribute('data-country') || '', notes: '', artworkSource: 'design', artworkSourceLabel: 'Use the design I created above', proofRepresents: 'designer' },
      recovery: { configuration: clone(configuration) }
    };
  }

  function handleClick(event) {
    if (event.target.closest('[data-order-confirmation-details-toggle]')) {
      var expanded = confirmationDetailsToggle.getAttribute('aria-expanded') === 'true';
      confirmationDetailsToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      confirmationDetailsToggle.textContent = expanded ? 'View details' : 'Hide details';
      confirmationDetails.hidden = expanded;
      return;
    }
    var step = event.target.closest('[data-order-quantity-step]');
    if (step) {
      var pricing = derivePricing(app.getState());
      updateOrder({ quantity: Math.max(Number(productData.rules.minimumCases), pricing.quantity + Number(step.getAttribute('data-order-quantity-step'))) });
      return;
    }
    if (event.target.closest('[data-order-edit-design]')) {
      app.goTo('edit');
      return;
    }
    if (event.target.closest('[data-order-edit-chopsticks]')) {
      app.goTo('chopsticks');
      return;
    }
    if (event.target.closest('[data-order-review]')) app.goTo('review');
  }

  function handleChange(event) {
    if (event.target.matches('[data-order-product]')) {
      updateOrder({ chopstickId: String(event.target.value) });
    }
    if (event.target.matches('[data-order-print-colors]')) {
      updateOrder({ printColors: Number(event.target.value) });
    }
  }

  function handleEmailInput() {
    updateOrder({ contactEmail: emailInput.value.slice(0, 254) });
  }

  function destroy() {
    if (destroyed) return;
    destroyed = true;
    if (confirmationCelebrationTimer) window.clearTimeout(confirmationCelebrationTimer);
    confirmationCelebrationTimer = null;
    if (unsubscribeApp) unsubscribeApp();
    if (unsubscribeArtwork) unsubscribeArtwork();
    if (pipeline) pipeline.destroy();
    orderFlow.removeEventListener('click', handleClick);
    orderFlow.removeEventListener('change', handleChange);
    if (emailInput) emailInput.removeEventListener('input', handleEmailInput);
    setOrderPageScrolling(false);
    root.removeAttribute('data-configurator-order-flow-initialized');
    root.configuratorOrderFlow = null;
  }

  orderFlow.addEventListener('click', handleClick);
  orderFlow.addEventListener('change', handleChange);
  if (emailInput) emailInput.addEventListener('input', handleEmailInput);
  unsubscribeArtwork = artworkApi.subscribe(handleArtwork);
  unsubscribeApp = app.subscribe(render);

  pipeline = window.ErsProofSubmission.attach({
    root: root, form: form, button: submitButton, email: emailInput, endpoint: proofStorageEndpoint,
    cacheKey: 'ers:custom-chopstick-sleeve:submitted-proof', submitLabel: 'Submit for Proof', succeeded: submissionSucceeded,
    getContext: submissionContext,
    restore: function (saved) { app.updateConfiguration(saved.configuration); app.goTo('review', { focus: false }); },
    fields: Object.fromEntries(['product', 'productUrl', 'productId', 'variantId', 'sku', 'chopstick', 'quantity', 'totalUnits', 'printColors', 'setupFee', 'estimatedTotal', 'reference', 'artworkUrl', 'storageSubmissionId', 'summary'].map(function (key) { return [key, '[data-order-form-field="' + key + '"]']; })),
    onError: function (message) { errorElement.textContent = message; if (message) errorElement.focus({ preventScroll: true }); },
    onSuccess: function () { app.goTo('confirmation', { focus: false }); }
  });

  root.configuratorOrderFlow = {
    derivePricing: function () { return clone(derivePricing(app.getState())); },
    submission: pipeline,
    destroy: destroy
  };

  pipeline.ready.then(function () { render(app.getState()); });
  render(app.getState());
}());
